import React from 'react';
import { Modal, Spinner, Form } from 'react-bootstrap';
import { FiTrash2 } from 'react-icons/fi';

const DraftModal = ({
  showDraftsModal,
  setShowDraftsModal,
  showDraftNameModal,
  setShowDraftNameModal,
  isLoadingDrafts,
  drafts,
  kitchens,
  loadDraft,
  deleteDraft,
  draftName,
  setDraftName,
  createDraft,
  isSavingDraft,
  draftType = 'production_indent' // 'production_indent' or 'grn'
}) => {
  const getDraftInfo = (draft) => {
    if (draftType === 'production_indent') {
      const kitchenName = kitchens.find(k => k.id === draft.saveData?.formDetails?.kitchenId)?.name || 'No kitchen selected';
      return `Kitchen: ${kitchenName}`;
    } else {
      const supplierName = draft.saveData?.grnForm?.supplierName || 'No vendor';
      const invoiceNumber = draft.saveData?.grnForm?.supplierInvoiceNumber || 'No invoice number';
      return `${supplierName} | ${invoiceNumber}`;
    }
  };

  return (
    <>
      {/* Drafts Modal */}
      <Modal size="md" show={showDraftsModal} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Load Draft</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowDraftsModal(false)}></button>
        </Modal.Header>
        <Modal.Body>
          {isLoadingDrafts ? (
            <div className="text-center">
              <Spinner animation="border" variant="primary" />
              <p>Loading drafts...</p>
            </div>
          ) : drafts.length === 0 ? (
            <p className="text-center">No drafts found</p>
          ) : (
            <div>
              {drafts.map((draft) => (
                <div key={draft.id} className="d-flex justify-content-between align-items-center border-bottom py-2">
                  <div>
                    <strong>{draft.name}</strong>
                    <br />
                    <small className="text-primary">
                      {getDraftInfo(draft)}
                    </small>
                    <br />
                    <small className="text-muted">
                      Updated: {new Date(draft.updatedAt).toLocaleDateString()}
                    </small>
                  </div>
                  <div>
                    <button
                      type="button"
                      className="btn app-btn-primary btn-sm me-2"
                      onMouseEnter={(e) => { e.target.style.boxShadow = '0 0 0 0.2rem rgba(0, 123, 255, 0.25)'; }}
                      onMouseLeave={(e) => { e.target.style.boxShadow = ''; }}
                      onClick={() => loadDraft(draft.id)}
                    >
                      Load
                    </button>
                    <FiTrash2
                      style={{ fontSize: '16px', color: 'red', cursor: 'pointer' }}
                      onClick={() => deleteDraft(draft.id)}
                      title="Delete Draft"
                    />
                  </div>
                </div>
              ))}
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* Draft Name Modal */}
      <Modal size="sm" show={showDraftNameModal} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Save Draft</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Draft Name</Form.Label>
            <Form.Control
              type="text"
              value={draftName}
              onChange={(e) => setDraftName(e.target.value)}
              placeholder="Enter draft name"
              autoFocus
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn app-btn-default btn-sm" onClick={() => { setShowDraftNameModal(false); setDraftName(''); }}>
            Cancel
          </button>
          <button type="button" className="btn app-btn-primary btn-sm" onClick={createDraft} disabled={isSavingDraft}>
            {isSavingDraft ? (
              <>
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                {' '}Saving...
              </>
            ) : (
              'Save'
            )}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DraftModal;